/**
 * Formats a bytes-per-second rate into a human-readable string.
 * Uses binary prefixes (KiB, MiB, GiB) for consistency with formatBytes.
 */
export const formatRate = (bytesPerSecond: number, decimals = 2): string => {
    if (!+bytesPerSecond) return '0 B/s';
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['B/s', 'KiB/s', 'MiB/s', 'GiB/s', 'TiB/s', 'PiB/s', 'EiB/s', 'ZiB/s', 'YiB/s'];
    const i = Math.max(0, Math.floor(Math.log(bytesPerSecond) / Math.log(k)));
    return `${parseFloat((bytesPerSecond / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
};
